import React from 'react';

import type { Nullable } from '@clearverify/types';
import { buildUrl } from '@clearverify/utils';

import { useNotification } from 'src/hooks/app';

export type EmployeeInviteLinkArgs = {
  route: string;
  paramKey: string;
  entityId: Nullable<string>;
  entityDisplayName?: Nullable<string>;
};

/**
 * Same generic signup URL is used for every pending employee of a given
 * employer/PEO/PEOPP — sign-up resolves the account via SSN.
 */
export const useCopyEmployeeInviteLink = (args: Nullable<EmployeeInviteLinkArgs>) => {
  const { spawnNotification } = useNotification();

  return React.useCallback(() => {
    if (!args?.entityId) return;
    navigator.clipboard
      .writeText(buildUrl(window.location.origin, args.route, { [args.paramKey]: args.entityId }))
      .then(() => spawnNotification('Signup link copied', 'success'))
      .catch(() => spawnNotification('Link not copied', 'error'));
  }, [args, spawnNotification]);
};
